import React from 'react';

import {
  PageSection,
  Flex,
  FlexItem,
  Panel,
  PanelMain,
  PanelMainBody,
  List,
  ListItem,
  Bullseye,
  Spinner,
  Content,
  PanelHeader,
  Divider,
  ContentVariants,
  EmptyState
} from '@patternfly/react-core';
import CubesIcon from '@patternfly/react-icons/dist/esm/icons/cubes-icon';

class ExamAnalysis extends React.Component {

  GetMediaUrl = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  render() {
    // const examresults = this.props.analysis_state?.examresults_data?.examresults || {};
    const examresults = this.props.analysis_state?.examresults_data?.examresults;

    if (!this.props.analysis_state?.isLoadedExamAnalysis) {
      return (
        <Bullseye style={{ height: '100vh' }}>
          <Spinner size="xl" />
        </Bullseye>
      );
    }

    if (!examresults || Object.keys(examresults).length === 0) {
      return (
        <EmptyState titleText="Brak danych" headingLevel="h4" icon={CubesIcon}></EmptyState>
      );
    }

    if (
    this.props.analysis_state?.isLoadedExamAnalysis &&
      examresults &&
      Object.keys(examresults).length > 0
    ) {
      return (
          <PageSection>
            <Flex gap={{ default: "gapMd" }}>
              {/* Odwrotna kolejność - latami */}
              {Object.entries(examresults).reverse().map(([school_year, items]) => (
                <FlexItem key={school_year}>
                  <Panel variant="raised">
                    <PanelHeader><Content component={ContentVariants.h3}>{school_year}</Content></PanelHeader>
                    <Divider />
                    <PanelMain>
                      <PanelMainBody>
                        {Object.entries(items).map(([qualification, analysis]) => (
                          <List isPlain isBordered key={qualification}>
                            <ListItem>
                              <span>{qualification}</span>
                              {Object.entries(analysis).map(([a, res]) => {
                                const baseUrl =
                                  `${this.props.state.api_url}/` +
                                  `${this.props.state.django_media_dir}/`;

                                return (
                                  <React.Fragment key={a}>
                                    {' '}
                                      <Content
                                        component={ContentVariants.a}
                                        style={{
                                          cursor: "pointer",
                                          marginLeft: "10px"
                                        }}
                                        onClick={() =>
                                          this.GetMediaUrl(
                                            `${baseUrl}${res.pdf_analysis_url}`
                                          )
                                        }
                                      >
                                        [pdf]
                                      </Content>

                                      <Content
                                        component={ContentVariants.a}
                                        style={{
                                          cursor: "pointer",
                                          marginLeft: "10px"
                                        }}
                                        onClick={() =>
                                          this.GetMediaUrl(
                                            `${baseUrl}${res.tex_analysis_url}`
                                          )
                                        }
                                      >
                                        [tex]
                                      </Content>
                                  </React.Fragment>
                                );
                              })}
                            </ListItem>
                          </List>
                        ))}
                      </PanelMainBody>
                    </PanelMain>
                  </Panel>
                </FlexItem>
              ))}
            </Flex>
          </PageSection>
      );
    }
    return null;
  }
}
export default ExamAnalysis;